module.exports = __webpack_public_path__ + "static/profile-e8dddb3081ffbff93b37ca9722826fdc.png";